import { Component, Injector, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { LegalEntityService, SearchResult } from 'src/app/services/legal-entity.service';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';

@Component({
    selector: 'app-dc-lei-lookup',
    templateUrl: './dc-lei-lookup.component.html',
    styleUrls: ['./dc-lei-lookup.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DcLeiLookupComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class DcLeiLookupComponent extends ControlValueAccessorConnector {
  @Input() readonly: boolean;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() field: any;
  searching = false;
  searchFailed = false;
  constructor(injector: Injector, private legalEntityService: LegalEntityService) {
    super(injector);
  }

  ngOnInit(): void {}

  legalNameSearch = (term: Observable<string>) => {
    return term.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      filter((value) => value.length > 2),
      switchMap((value) => this.legalEntityService.searchAll(value))
    );
  };
  searchInputFormatter = (result: SearchResult) => result.value;
  searchResultFormatter = (result: SearchResult) => result;
}
